import * as React from 'react';
import * as styles from './styles.css';
import { Card } from '../Card';
import { ICardsQuestionProps } from '../../types';

export const CardsQuestion: React.FC<ICardsQuestionProps> = props => {
  return (
    <div className={styles['cards']}>
      {props.cards.map(card => (
        <Card key={card.value} {...card} onClick={props.handleSelect} iconType={props.iconType} />
      ))}
    </div>
  );
};

CardsQuestion.displayName = 'CardsQuestion';
